<template>
  <div class="container">
    <div class="top_title">
      <router-link class="icon_back" :to="{name:'H010010'}" tag="span"></router-link>
      <p>阅读排名</p>
    </div>
    <div style="background-color: #eee;position: fixed;top: 2.4rem;width: 100%;">
      <div class="weui-flex top_tabs">
        <div class="weui-flex__item"><span :class="{active: I_FLAG1 == 1}" @click="changeTab('I_FLAG1',1)">最近一周</span></div>
        <div class="weui-flex__item"><span  :class="{active: I_FLAG1 == 2}" @click="changeTab('I_FLAG1',2)">最近一月</span></div>
      </div>
    </div>

    <div class="items">
      <div class="item" v-for="i in dataList">
        <p class="no">{{i.I_NO}}</p>
        <p class="school-name">{{i.I_SCHOOL_NAME}}</p>
        <p class="name">{{i.I_NAME}}</p>
        <p class="num">{{i.I_NUM}}<span class="special">本</span></p>
      </div>
    </div>
    <!--<table class="items">-->
      <!--<tr class="item" v-for="i in dataList">-->
        <!--<td class="no">{{i.I_NO}}</td>-->
        <!--<td class="name">{{i.I_NAME}}</td>-->
        <!--<td class="amt">{{i.I_AMT}}<span class="special">元</span></td>-->
        <!--<td class="num">{{i.I_NUM}}<span class="special">人</span></td>-->
      <!--</tr>-->
    <!--</table>-->
  </div>
</template>

<script>
  import DataRequestFactory from '@/factories/dataRequestFactory.js'
  export default {
    name: "H500010",
    data() {
      return {
        I_FLAG1: 1,
        I_FLAG2: 1,
        dataList: []
      }
    },
    created() {
      this.search()
    },
    methods: {
      changeTab(key,value) {
        this[key] = value
        this.search()
      },
      search() {
        let param = {
          I_FLAG1: this.I_FLAG1,
          I_FLAG2: this.I_FLAG2
        }
        DataRequestFactory.I500020(param).then((response) => {
          console.log(response)
          if(response.resultCode == '0') {
            this.dataList = response.dataList
          }
        })
      }
    }
  }
</script>

<style scoped>
  @import '../assets/css/pages/H500020.css';
  @import '../assets/css/common.css';
</style>



// WEBPACK FOOTER //
// src/pages/H500020.vue